import { getFormattedDuration } from './getFormattedDuration';

export const waitingTimeOptions = [];

for (let i = 0; i <= 86400; i += 1800) {
  waitingTimeOptions.push({ label: getFormattedDuration(i), value: i });
}
